exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#bodyContainer {\n  width: 100%;\n  height: 100%;\n  background-color: rgb(230, 230, 230);\n  text-align: center;\n}\n\n.arrayElement {\n  padding-top: 7px;\n  font-family: sans-serif;\n  font-weight: 700;\n  display: inline-block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/components/Main/Body/Body.css
// module id = 395
// module chunks = 0